import { render, staticRenderFns } from "./SortBySelector.vue?vue&type=template&id=c2f4efa2&scoped=true"
import script from "./SortBySelector.vue?vue&type=script&lang=js"
export * from "./SortBySelector.vue?vue&type=script&lang=js"
import style0 from "./SortBySelector.vue?vue&type=style&index=0&id=c2f4efa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f4efa2",
  null
  
)

export default component.exports